export default __webpack_public_path__ + "static/hexImg-810777c8dae221defadde6ab041e3433.png";